import EditPageDialog from "../../../components/edit-page.dialog";
import { FormItem, FormType } from "../../../components/form/form-generator";
import { FileUploadCategory } from "../../../services/file-upload.service";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { updateBirthPage } from "../apis/birth-page.api";
import { BirthPageDetailsEntity } from "../entities/birth-page-details.entity";
import { BirthPageEditEntity } from "../entities/birth-page-edit.entity";
import { BirthPageEditModel } from "../models/birth-page-edit.model";

const formElements: FormItem[] = [
  {
    title: "Description",
    contentKey: "description",
    type: FormType.textArea,
  },
];

export default function EditBirthPageDialog({
  open,
  setOpen,
  birthPage,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  birthPage: BirthPageDetailsEntity;
}) {
  const setAlert = useDashboardStore((state) => state.setAlert);
  const onSave = async (values: any) => {
    updateBirthPage(BirthPageEditModel.fromEntity(values))
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        setAlert({
          message: error.response.data.message,
          type: AlertType.error,
        });
      });
  };

  return (
    <EditPageDialog
      title="Edit Birth Page"
      open={open}
      setOpen={setOpen}
      page={BirthPageEditEntity.fromDetailsEntity(birthPage)}
      formElements={formElements}
      onSaveClick={onSave}
      uploadCategory={FileUploadCategory.BIRTH}
    />
  );
}
